exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-detail[data-v-4510b3b6] {\n  min-height: 80vh;\n  background-color: #fff;\n  border-radius: 10px;\n}\n.page-header[data-v-4510b3b6] {\n  padding: 10px 20px;\n}\n.page-header[data-v-4510b3b6] .ant-page-header-heading-title {\n  font-size: 14px;\n}\n", ""]);

// exports
